import './Contact.css';
import SEO from '../../../components/SEO/SEO';
import email from '../../../resources/email.png'
import emailjs from 'emailjs-com'

function Contact({ showSEO = true }) {

    function sendEmail(e) {
        e.preventDefault();

        emailjs.sendForm('service_apg26uw', 'template_oyzui0w', e.target, 'JkPb7Ow4fczmWadFK')
            .then((result) => {
                alert("Your message was sent successfully.")
                window.location.reload()
            }, (error) => {
                alert("An error occured.")
                console.log(error.text);
            });
    }


    return (
        <div className='all_margin' id='contact'>
            {showSEO && (
                <SEO
                    title="Contact Us"
                    description="Get in touch with the PrepWize team. We're here to help with any questions about our AI-powered calorie tracker app."
                    url="https://prepwize.ai/contact-us"
                />
            )}
            <div className='margin_auto_width'>
                <div className='contact_main_div padding_top padding_bottom'>
                    <div>
                        <h1>We’d Love To Hear <span className='green_gradient_p_animated'>From You</span></h1>
                        <p className='gray_scale_2 font_size_18'>Have questions or need support? Reach out to us anytime—we’re here to assist you and ensure you have the best experience possible.</p>

                        <div className='contact_detail_div'>
                            {/* <div className='flex align_center gap_20'>
                                <img src={location} className='contact_detail_icon' />
                                <p className='gray_scale_2 font_size_18'>1801 Research Blvd Suite 550, Rockville, MD 20850</p>
                            </div>
                            <div className='flex align_center gap_20'>
                                <img src={phone} className='contact_detail_icon' />
                                <p className='gray_scale_2 font_size_18'>+1 (240) 489 - 1974</p>
                            </div> */}
                            <div className='flex align_center gap_20'>
                                <img src={email} className='contact_detail_icon' />
                                <p className='gray_scale_2 font_size_18'>support@prepwize.ai</p>
                            </div>
                        </div>
                    </div>

                    <div>
                        <form action="/submit_inquiry" method="post" className='contact_form' onSubmit={sendEmail}>
                            <div className='contact_form_indiv_div'>
                                <p className='font_size_16 gray_scale_6'>Full Name</p>
                                <input type="text" id="from_full_name" className='contact_input'
                                    name="from_full_name" required placeholder='Full Name' />
                            </div>
                            <div className='contact_form_indiv_div'>
                                <p className='font_size_16 gray_scale_6'>Email</p>
                                <input type="email" id="from_email" className='contact_input'
                                    name="from_email" required placeholder='Email Address' />
                            </div>
                            <div className='contact_form_indiv_div'>
                                <p className='font_size_16 gray_scale_6'>Reason</p>
                                <select name="from_reason" className='contact_select'>
                                    <option value="General Inquiry">General Inquiry</option>
                                    <option value="Support Request">Support Request</option>
                                    <option value="Feedback">Feedback</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div className='contact_form_indiv_div'>
                                <p className='font_size_16 gray_scale_6'>Message</p>
                                <textarea id="message" name="message" className='contact_input contact_textarea' maxlength="250"
                                    rows="5" required placeholder='Message'></textarea>
                            </div>

                            <input type="submit" value="Submit" className='contact_submit green_gradient' />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Contact;
